import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-red-400 text-center py-10'>
      <p>copyright &copy; 2023. coded by <span className='text-lg font-bold text-blue-800'>Ahmed Ismail</span>.</p>
    </footer>
  )
}

export default Footer
